import CadastroItem from './CadastroItem'
import enhance from './CadastroItem.enhancer'

export default enhance(CadastroItem)



// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/components/TabelaItensCustomForm/CadastroItem/index.js